import React, { Suspense } from 'react';
const StoreTransferComponent = React.lazy(() => import('../Component/StoreTransferComponent/StoreTransferComponent'));
function StoreTransferPage(props) {
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <StoreTransferComponent />
      </Suspense>
    </>
  );
}

export default StoreTransferPage;
